import { UI, HStack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { LateralBar } from '../../../../../../components/LateralBar';
import { getPrivatePensionCardLabels, ItemDataInfo } from '../PrivatePensionCard/constants';
import { PrivatePensionCardItem } from '../PrivatePensionCardItem';

export const PrivatePensionCardLoading = () => {
  const numColumns = useBreakpointValue({ base: 1, sm: 4, lg: 6 });

  const renderInfo = (item: ItemDataInfo) => {
    return <PrivatePensionCardItem label={item.label} numColumns={numColumns} isLoading />;
  };

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy} p={Spacing['stack.xxxs']}>
      <LateralBar barColor="product.previdencia" />
      <VStack space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between">
          <UI.Text isLoading maxW="2/3" />
        </HStack>
        <Box w="full" h="1px" backgroundColor={Color['neutral.lightest']} />
        <FlatList
          key={`private-pension-card-flatlist-${numColumns}`}
          data={getPrivatePensionCardLabels()}
          showsVerticalScrollIndicator={false}
          renderItem={({ item }) => renderInfo(item)}
          ItemSeparatorComponent={() => <Box h="16px" />}
          numColumns={numColumns}
        />
      </VStack>
    </UI.Shadow>
  );
};
